export default "__VITE_ASSET__BQx_6Gf1__"